import { AxiosInstance } from "axios";
import saveByteArray from "src/util/saveByteArray";
import { FilesCategoryEnum, FilesCategoryEnumLabel } from "../Enum/FilesCategoryEnum";
import { ApiService } from "../models/Api.model";

enum FileServiceEnum {
  downloadTemplateDocument = "/template"
}
export default class FileService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/file");
  }

  public downloadTemplateDocument = async (category: FilesCategoryEnum, extension: 'pdf' | 'xlsx') => {
    const filename = `${FilesCategoryEnumLabel.get(category)}.${extension}`;
    const endpoint = `${FileServiceEnum.downloadTemplateDocument}?documentCategory=${FilesCategoryEnum[category]}`;
    const data = await this.GET(endpoint, "blob");

    saveByteArray(filename, data);
    return data;
  };
}



// WEBPACK FOOTER //
// ./src/services/api/File.service.ts